export default __webpack_public_path__ + "static/img/vogue_scene_animated_0574.ee49eb2.jpg";